
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
// import { test } from '@/interfaces/components/test';

@Component({
    name: 'InternalOrder',
})
export default class InternalOrder extends Vue {
    @Prop({ default: false }) private readonly order!: any;
}
